import _ColorConversions from './ColorConversions.frag';
import _GLNoise from './GLNoise.frag';
import _LFO from './LFO.frag';
import _PhoenixFBMNoise from './PhoenixFBMNoise.frag';

const ColorConversions = {
	name: 'ColorConversions',
	fs: _ColorConversions
};

const GLNoise = {
	name: 'GLNoise',
	fs: _GLNoise
};

const LFO = {
	name: 'LFO',
	fs: _LFO
};

const PhoenixFBMNoise = {
	name: 'PhoenixFBMNoise',
	fs: _PhoenixFBMNoise
};

export { ColorConversions, GLNoise, LFO, PhoenixFBMNoise };
